import { Box, Button, Typography, useTheme } from "@mui/material";
import { getTerm, VerticalNavigationComponentProps } from "@sal/onevent-portal";
import AddIcon from "@mui/icons-material/Add";

export function VerticalNavigationActionButton({ collapsed }: VerticalNavigationComponentProps) {
	const theme = useTheme();

	const buttonSx = {
		paddingY: collapsed ? theme.spacing(2) : theme.spacing(3),
		minWidth: collapsed ? "auto" : "initial"
	};

	return (
		<>
			<Box
				display="flex"
				flexDirection={"column"}
				alignItems="center"
				justifyContent="center"
				width="100%"
				paddingX={collapsed ? 0 : 6}
				paddingBottom={2}
				gap={4}
			>
				<Button
					variant="contained"
					color="secondary"
					fullWidth={!collapsed}
					title={getTerm("navigation_NewConsignment")}
					sx={buttonSx}
					onClick={() => (window.location.href = "/#/FreightBooking")}
				>
					<Typography
						fontSize={collapsed ? "large" : "0.85rem"}
						color={theme.palette.common.white}
						sx={{ display: "flex", alignItems: "center", gap: 1 }}
					>
						<AddIcon fontSize="inherit" />
						{!collapsed && <span>{getTerm("navigation_NewConsignment")}</span>}
					</Typography>
				</Button>
				<Button
					variant="contained"
					color="secondary"
					fullWidth={!collapsed}
					title={getTerm("navigation_NewOrder")}
					sx={buttonSx}
					onClick={() => (window.location.href = "/#/Order")}
				>
					<Typography
						fontSize={collapsed ? "large" : "0.85rem"}
						color={theme.palette.common.white}
						sx={{ display: "flex", alignItems: "center", gap: 1 }}
					>
						<AddIcon fontSize="inherit" />
						{!collapsed && <span>{getTerm("navigation_NewOrder")}</span>}
					</Typography>
				</Button>
			</Box>
		</>
	);
}
